import Utils from '@/common/utils/utils';
import EmailRichtext from '../../../../project/EmailResponseSetting/EmailRichtext';
import { I18n } from 'aws-amplify';

function ContentMailBody({
    fieldData,
    isCustomerMail,
    isDeliverTicket,
    isDisableLink,
    isDisableEdit,
    onclickReplyTicket,
    setIsEditedCurrentTicket,
    currentMailBody,
    setCurrentMailBody
}) {
    return (
        <>
            {isCustomerMail || isDeliverTicket ? (
                <MailBodyViewOnly
                    fieldData={fieldData}
                    isCustomerMail={isCustomerMail}
                    isDeliverTicket={isDeliverTicket}
                    isDisableLink={isDisableLink}
                    isDisableEdit={isDisableEdit}
                    onclickReplyTicket={onclickReplyTicket}
                />
            ) : (
                <div className="form-addTicket">
                    <EmailRichtext
                        label={I18n.get('EMAIL_BODY')}
                        disable={isDisableEdit}
                        richtextValue={currentMailBody}
                        setRichtextValue={setCurrentMailBody}
                        setIsEdited={setIsEditedCurrentTicket}
                        isRequired={true}
                        isValidateWhenBlur={true}
                    />
                </div>
            )}
        </>
    );
}

export default ContentMailBody;

const MailBodyViewOnly = ({
    fieldData,
    isCustomerMail,
    isDisableLink,
    isDisableEdit,
    onclickReplyTicket
}) => {
    let bodyHtml = '';
    if (Utils.isValidJSONString(fieldData?.value)) {
        bodyHtml = JSON.parse(fieldData?.value);
        return (
            <div className="form-addTicket">
                <div className="mailBody-title-wrap">
                    <div className="cell-prod-status gap-8">
                        <label className="form-addTicket-label">{I18n.get('EMAIL_BODY')}</label>
                        {true && <span className="required">*</span>}
                    </div>
                    {isCustomerMail && (
                        <span
                            className={`send-msg-hyper-link ${
                                isDisableLink || isDisableEdit ? 'send-msg-hyper-link-disable' : ''
                            }`}
                            onClick={() => {
                                if (isDisableLink || isDisableEdit) return;
                                onclickReplyTicket();
                            }}
                        >
                            このメッセージに返信
                        </span>
                    )}
                </div>
                <div className="mailBody-content">
                    <div dangerouslySetInnerHTML={{ __html: bodyHtml }} />
                </div>
            </div>
        );
    } else {
        return (
            <div className="form-addTicket">
                <EmailRichtext
                    label={I18n.get('EMAIL_BODY')}
                    disable={true}
                    richtextValue={fieldData}
                    setRichtextValue={() => {}}
                    setIsEdited={() => {}}
                    isRequired={true}
                    isValidateWhenBlur={true}
                    isCustomerMail={isCustomerMail}
                    isDisableLink={isDisableEdit}
                    isDisableEdit={isDisableLink}
                    onclickReplyTicket={onclickReplyTicket}
                />
            </div>
        );
    }
};
